<script lang="ts" setup>
import { setI18nLanguage } from '@/i18n'

async function changeLanguage(language: string) {
  await setI18nLanguage(language)
}
</script>

<template>
  <button
    v-if="$i18next.language === 'it'"
    class="flex items-center gap-2"
    @click.prevent="changeLanguage('en')"
  >
    <img alt="Italiano" src="../../assets/flags/it.svg?url" />
    <span>IT</span>
  </button>
  <button v-else class="flex items-center gap-2" @click.prevent="changeLanguage('it')">
    <img alt="English" src="../../assets/flags/en.svg?url" />
    <span>EN</span>
  </button>
</template>
